var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal__container-inner"},[_c('div',{staticClass:"modal__pdf-container"},[_c('vue-pdf-app',{attrs:{"pdf":_vm.getCurUrl}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }